// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"6f030e53","453":"670e15c7","536":"6abca2b2","545":"2043937e","574":"aa9c502f","672":"d98744b3","704":"f066f583","789":"95b66d3b","814":"ab691e23","932":"7e5b8a6e","975":"047928ac","979":"e08c66e0"}[chunkId] + ".chunk.js";
};